/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from '@tanstack/react-table';
import { Checkbox } from '@mui/material';
import {
  updateDoc,
  doc,
  collection,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../../firebase';
import { FormIds } from '../../services';
import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { User } from '../../types';
//import { Checkbox } from '@mui/material';
// import { doc, updateDoc } from 'firebase/firestore';
// import { db } from '../../firebase';

const SubmittedBreastCancer2 = () => {
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const [userData, setUserData] = useState<User>();

  const [forms, setForms] = React.useState<any[]>([]);
  const [sorting, setSorting] = React.useState<SortingState>([
    // {
    //   id: 'First Name',
    //   desc: false,
    // },
    // {
    //   id: 'Last Name',
    //   desc: false,
    // },
  ]);

  const markAsPaid = async (id: string, paid: boolean) => {
    const ref = doc(db, 'forms', id);

    await updateDoc(ref, {
      paid,
    });
  };

  const setComplimentary = async (id: string, complimentaryShirts: boolean) => {
    const ref = doc(db, 'forms', id);

    await updateDoc(ref, {
      complimentaryShirts,
    });
  };

  console.log({ forms });
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        header: '#',
        accessorKey: 'id',
        cell: (v) => v.row.index + 1,
      },
      // {
      //   header: 'id',
      //   accessorKey: 'id',
      //   cell: (v) => (
      //     <a
      //       target="_blank"
      //       href={`https://console.firebase.google.com/project/nmzlakeland-a8568/firestore/data/~2Fforms~2F${v.row.original.id}`}
      //       rel="noreferrer"
      //     >
      //       {v.row.original.id}
      //     </a>
      //   ),
      // },
      {
        header: 'First Name',
        accessorKey: 'First Name',
      },
      {
        header: 'Last Name',
        accessorKey: 'Last Name',
      },
      {
        header: 'Phone Number',
        accessorKey: 'Phone Number',
      },
      {
        header: 'Breast Cancer Survivor',
        accessorKey: 'Are you a Breast Cancer Survivor?',
      },
      {
        header: 'Ordered T-Shirt or Cap',
        accessorKey: 'Would you like to order a T-Shirt or Cap?',
        //cell: (v) => (v.getValue() === true ? 'Yes' : 'No'),
      },
      {
        header: 'T-Shirt Size(s)/Cap',
        accessorKey: 'tshirtSize',
        cell: (v) =>
          v.row.original['Would you like to order a T-Shirt or Cap?'] ===
          'Yes' ? (
            <div style={{ whiteSpace: 'break-spaces', lineHeight: '1.5rem' }}>
              {v.row.original['T-Shirt Size'].split(' -')[0]},{' '}
              {v.row.original['T-Shirt Gender']}
              {v.row.original['Caps']
                ? `\n${v.row.original['Caps'].split(' -')[0]}`
                : ''}
            </div>
          ) : (
            <></>
          ),
      },
      {
        header: 'Payment Method',
        accessorKey: 'Payment method',
      },
      // {
      //   header: 'Complimentary Shirts',
      //   accessorKey: 'complimentaryShirts',
      //   cell: (v) => (
      //     <>{v.row.original.complimentaryShirts === true ? 'Yes' : 'No'}</>
      //   ),
      // },
      // {
      //   header: 'Email',
      //   accessorKey: 'email',
      // },
      // {
      //   header: 'Phone',
      //   accessorKey: 'phone',
      // },
      // {
      //   header: 'Paid?',
      //   accessorKey: 'paid',
      //   cell: (v) => (
      //     <Checkbox
      //       onChange={(e) => markAsPaid(v.row.original.id, e.target.checked)}
      //       checked={v.row.original.paid === true}
      //     />
      //   ),
      // },
      // {
      //   header: 'Complimentary Shirts',
      //   accessorKey: 'complimentaryShirts',
      //   cell: (v) => (
      //     <Checkbox
      //       onChange={(e) =>
      //         setComplimentary(v.row.original.id, e.target.checked)
      //       }
      //       checked={v.row.original.complimentaryShirts === true}
      //     />
      //   ),
      // },
    ],
    []
  );

  useEffect(() => {
    if (user?.uid) {
      const unsub = onSnapshot(doc(db, 'users', user.uid), (doc) => {
        if (doc.exists()) {
          setUserData(doc.data() as User);
        }
      });
      return () => unsub();
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    if (!userData?.isAdmin) return;
    const q = query(
      collection(db, 'forms'),
      where('formId', 'in', [FormIds.breastCancerSeminar2025])
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const z: any[] = [];
      querySnapshot.forEach((doc) => {
        const f: any = { ...doc.data(), ...{ id: doc.id } };
        //con
        if (f.formId) {
          const idx = z.findIndex((x) => x.formId === f.formId);
          if (idx === -1) {
            z.push({
              formId: f.formId,
              formName: 'Breast Cancer Seminar 2025',
              forms: [f],
            });
          } else {
            z[idx].forms.push(f);
          }
        }
      });
      setForms(
        z[0]?.forms.sort((a: any, b: any) => {
          const lastNameA = a['Last Name'];
          const lastNameB = b['Last Name'];

          if (lastNameA < lastNameB) return -1;
          if (lastNameA > lastNameB) return 1;
          return 0;
        }) || []
      );
    });
    return () => {
      unsubscribe();
    };
  }, [user, userData?.isAdmin]);

  const data = forms;

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <div className="p-2">
      <table style={{ borderCollapse: 'collapse' }}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    style={{
                      border: '1px solid black',
                      padding: '10px',
                      backgroundColor: '#ddd',
                      cursor: 'pointer',
                    }}
                  >
                    {header.isPlaceholder ? null : (
                      <div
                        {...{
                          className: header.column.getCanSort()
                            ? 'cursor-pointer select-none'
                            : '',
                          onClick: header.column.getToggleSortingHandler(),
                        }}
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: ' 🔼',
                          desc: ' 🔽',
                        }[header.column.getIsSorted() as string] ?? null}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table
            .getRowModel()
            .rows.slice(0, 1000)
            .map((row) => {
              return (
                <tr
                  key={row.id}
                  style={{
                    color: row.original.survivor === 'Yes' ? 'red' : 'black',
                  }}
                >
                  {row.getVisibleCells().map((cell) => {
                    return (
                      <td
                        key={cell.id}
                        style={{ border: '1px solid black', padding: '5px' }}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default SubmittedBreastCancer2;
